import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerifyIncidentDialogComponent } from './components/verify-incident-dialog/verify-incident-dialog.component';
import { SnoozeIncidentDialogComponent } from './components/snooze-incident-dialog/snooze-incident-dialog.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { VisitorTicketDialogComponent } from './components/visitor-ticket-dialog/visitor-ticket-dialog.component';
import { IncidentTicketDialogComponent } from './components/incident-ticket-dialog/incident-ticket-dialog.component';
import { LoginScreenDialogComponent } from './components/login-screen-dialog/login-screen-dialog.component';
import { AddUserDialogComponent } from './components/add-user-dialog/add-user-dialog.component';
import { RemoveUserDialogComponent } from './components/remove-user-dialog/remove-user-dialog.component';
import { SaveUserDialogComponent } from './components/save-user-dialog/save-user-dialog.component';
import { DeleteUserAccountDialogComponent } from './components/delete-user-account-dialog/delete-user-account-dialog.component';
import { LoadingDashboardDialogComponent } from './components/loading-dashboard-dialog/loading-dashboard-dialog.component';
import { AssetSettingsDialogComponent } from './components/asset-settings-dialog/asset-settings-dialog.component';
import { LodgeComplaintDiaogComponent } from './components/lodge-complaint-diaog/lodge-complaint-diaog.component';
import { PreApproveDialogComponent } from './components/pre-approve-dialog/pre-approve-dialog.component';
import { RapidScheduleVisitorComponent } from './components/rapid-schedule-visitor/rapid-schedule-visitor.component';
import { UserEventDialogComponent } from './components/user-event-dialog/user-event-dialog.component';
import { UserPreapprovedDialogComponent } from './components/user-preapproved-dialog/user-preapproved-dialog.component';
import { UserPollsDialogComponent } from './components/user-polls-dialog/user-polls-dialog.component';
import { LoadingSpinnerDialogComponent } from './components/loading-spinner-dialog/loading-spinner-dialog.component';
import { PreApprovedVisitorDialogComponent } from './components/pre-approved-visitor-dialog/pre-approved-visitor-dialog.component';
import { WebcamModule } from 'ngx-webcam';
import { NgOtpInputModule } from 'ng-otp-input';
import { PasswordChangeDialogComponent } from './components/password-change-dialog/password-change-dialog.component';
import { PasswordChangePopupDialogComponent } from './components/password-change-popup-dialog/password-change-popup-dialog.component';
import { ForgetPasswordDialogComponent } from './components/forget-password-dialog/forget-password-dialog.component';
import { PollResultDialogComponent } from './components/poll-result-dialog/poll-result-dialog.component';
import { VisitorDetailsDialogComponent } from './components/visitor-details-dialog/visitor-details-dialog.component';
import { SendReportsEmailDialogComponent } from './components/send-reports-email-dialog/send-reports-email-dialog.component';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';
import { ManageVisitorPassDialogComponent } from './components/manage-visitor-pass-dialog/manage-visitor-pass-dialog.component';
import { SharedPipesModule } from '../../../shared/pipe/shared-pipes.module';
import { ExisitingVisitorDialogComponent } from './components/exisiting-visitor-dialog/exisiting-visitor-dialog.component';
import { PleaseWaitDialogComponent } from './components/please-wait-dialog/please-wait-dialog.component';
import { IncidentDetailsDialogComponent } from './components/incident-details-dialog/incident-details-dialog.component';
import { UserLocationPermissionDialogComponent } from './components/user-location-permission-dialog/user-location-permission-dialog.component';
import { AnalyticsInformationDialogComponent } from './components/analytics-information-dialog/analytics-information-dialog.component';
import { PreapprovedSelectionDialogComponent } from './components/preapproved-selection-dialog/preapproved-selection-dialog.component';
import { UploadFileDialogComponent } from './components/upload-file-dialog/upload-file-dialog.component';
import { AgGridModule } from 'ag-grid-angular';
import { MapsLocationDialogComponent } from './components/maps-location-dialog/maps-location-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { TokenExpiredDialogComponent } from './components/token-expired-dialog/token-expired-dialog.component';
import { VisitorTokenExpiredDialogComponentComponent } from './components/visitor-token-expired-dialog-component/visitor-token-expired-dialog-component.component';
import { UserSelfAttendnaceDialogComponent } from './components/user-self-attendnace-dialog/user-self-attendnace-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { EmployeeAttendanceResponseDialogComponent } from './components/employee-attendance-response-dialog/employee-attendance-response-dialog.component';
import { SelectOrganizationDialogComponent } from './components/select-organization-dialog/select-organization-dialog.component';
import { WordFileHandlerComponent } from './components/word-file-handler/word-file-handler.component';
// import { RapidVisitorProxyComponent } from './components/rapid-visitor-proxy/rapid-visitor-proxy.component';

const components = [
  VerifyIncidentDialogComponent,
  SnoozeIncidentDialogComponent,
  VisitorTicketDialogComponent,
  IncidentTicketDialogComponent,
  LoginScreenDialogComponent,
  AddUserDialogComponent,
  RemoveUserDialogComponent,
  SaveUserDialogComponent,
  DeleteUserAccountDialogComponent,
  LoadingDashboardDialogComponent,
  AssetSettingsDialogComponent,
  LodgeComplaintDiaogComponent,
  PreApproveDialogComponent,
  RapidScheduleVisitorComponent,
  // RapidVisitorProxyComponent,
  UserEventDialogComponent,
  UserPreapprovedDialogComponent,
  UserPollsDialogComponent,
  LoadingSpinnerDialogComponent,
  PreApprovedVisitorDialogComponent,
  PasswordChangeDialogComponent,
  PasswordChangePopupDialogComponent,
  ForgetPasswordDialogComponent,
  PollResultDialogComponent,
  VisitorDetailsDialogComponent,
  UserLocationPermissionDialogComponent,
  SendReportsEmailDialogComponent,
  ManageVisitorPassDialogComponent,
  ExisitingVisitorDialogComponent,
  PleaseWaitDialogComponent,
  IncidentDetailsDialogComponent,
  AnalyticsInformationDialogComponent,
  PreapprovedSelectionDialogComponent,
  UploadFileDialogComponent,
  MapsLocationDialogComponent,
  TokenExpiredDialogComponent,
  VisitorTokenExpiredDialogComponentComponent,
  UserSelfAttendnaceDialogComponent,
  EmployeeAttendanceResponseDialogComponent,
  SelectOrganizationDialogComponent,
  WordFileHandlerComponent,
];

@NgModule({
  declarations: [...components],
  exports: [CommonModule, ...components],
  imports: [
    CommonModule,
    MaterialModule,
    WebcamModule,
    NgOtpInputModule,
    NgxMatIntlTelInputComponent,
    SharedPipesModule,
    AgGridModule,
    GoogleMapsModule,
    PdfViewerModule,
  ],
})
export class DialogPopUpsModule {}
